import { useState, useEffect, useContext } from "react";
import "./HomePage.css";

import {
  getJobsCreatedToday,
  getJobsCreatedThisMonth,
  getQuotesCreatedToday,
  getQuotesCreatedThisMonth,
  getQuotesWonPercent,
  getQuotesRecent,
  getEnquiriesCreatedToday,
  getEnquiriesCreatedThisMonth,
  getEnquiriesNotQuoted,
  getInvoicesCreatedThisMonth,
  getChartData,
  getInvoicesCreatedToday,
  getJobsCompletedToday,
  getQuotesWonToday,
  getQuotesWonPercentLastYear,
} from "../data/dashboardData";

import { logoWhiteSVG } from "../assets";

import GenericStat from "../components/Charts/Stats/GenericStat";
import MainQuoteWorkChart from "../components/Charts/DataComparisonChart/MainQuoteWorkChart";
import MainJobWorkChart from "../components/Charts/DataComparisonChart/MainJobWorkChart";
import InvoiceCompletedChart from "../components/Charts/InvoiceCompletedChart/InvoiceCompletedChart";
import WeatherWidget from "../components/WeatherWidget";

const HomePage = (props: any) => {
  const [jobsToday, setJobsToday] = useState(0);
  const [jobsCompletedToday, setJobsCompletedToday] = useState(0);
  const [jobsMonth, setJobsMonth] = useState(0);
  const [quotesToday, setQuotesToday] = useState(0);
  const [quotesWonToday, setQuotesWonToday] = useState(0);
  const [quotesMonth, setQuotesMonth] = useState(0);
  const [quotesWon, setQuotesWon] = useState(0);
  const [quotesWonYearToDate, setQuotesWonYearToDate] = useState(0);
  const [quotesRecent, setQuotesRecent] = useState(0);
  const [enquiriesToday, setEnquiriesToday] = useState(0);
  const [enquiriesMonth, setEnquiriesMonth] = useState(0);
  const [enquiriesNotQuoted, setEnquiriesNotQuoted] = useState(0);
  const [invoicesMonth, setInvoicesMonth] = useState(0);
  const [invoicesToday, setInvoicesToday] = useState(0);
  const [chartData, setChartData] = useState<any[]>([]); 
  const [time, setTime] = useState(Date.now());
  
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(Date.now());
    }, 60000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    const fetchJobsToday = async () => {
      await getJobsCreatedToday().then((data) => {
        setJobsToday(data);
      });
    };
    const fetchJobsCompletedToday = async () => {
      await getJobsCompletedToday().then((data) => {
        setJobsCompletedToday(data);
      });
    };
    const fetchJobsMonth = async () => {
      await getJobsCreatedThisMonth().then((data) => {
        setJobsMonth(data);
      });
    };
    const fetchQuotesToday = async () => {
      getQuotesCreatedToday().then((data) => {
        setQuotesToday(data);
      });
    };
    const fetchQuotesWonToday = async () => {
      getQuotesWonToday().then((data) => {
        setQuotesWonToday(data);
      });
    };
    const fetchQuotesMonth = async () => {
      getQuotesCreatedThisMonth().then((data) => {
        setQuotesMonth(data);
      });
    };
    const fetchQuotesWon = async () => {
      getQuotesWonPercent().then((data) => {
        setQuotesWon(data);
      });
    };
    const fetchQuotesWonYearToDate = async () => {
      getQuotesWonPercentLastYear().then((data) => {
        setQuotesWonYearToDate(data);
      });
    };
    const fetchQuotesRecent = async () => {
      getQuotesRecent().then((data) => {
        setQuotesRecent(data);
      });
    };
    const fetchEnquiriesToday = async () => {
      getEnquiriesCreatedToday().then((data) => {
        setEnquiriesToday(data);
      });
    };
    const fetchEnquiriesMonth = async () => {
      getEnquiriesCreatedThisMonth().then((data) => {
        setEnquiriesMonth(data);
      });
    };
    const fetchEnquiriesNotQuoted = async () => {
      getEnquiriesNotQuoted().then((data) => {
        setEnquiriesNotQuoted(data);
      });
    };
    const fetchInvoicesMonth = async () => {
      getInvoicesCreatedThisMonth().then((data) => {
        setInvoicesMonth(data);
      });
    };
    const fetchInvoicesToday = async () => {
      getInvoicesCreatedToday().then((data) => {
        setInvoicesToday(data);
      });
    };
    const fetchChartData = async () => {
      getChartData().then((data) => {
        setChartData(data);
      });
    };

    fetchJobsToday();
    fetchJobsCompletedToday();
    fetchJobsMonth();
    fetchQuotesToday();
    fetchQuotesWonToday();
    fetchQuotesMonth();
    fetchQuotesWon();
    fetchQuotesWonYearToDate();
    fetchQuotesRecent();
    fetchEnquiriesToday();
    fetchEnquiriesMonth();
    fetchEnquiriesNotQuoted();
    fetchInvoicesMonth();
    fetchChartData();
    fetchInvoicesToday();
  }, [time]);

  return (
    <div className="welcome__container">
      <div className="welcome__header">
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center", gap: "30px" }}>
          <img style={{width: "13%"}} src={logoWhiteSVG} alt="logo" />
          <WeatherWidget />
        </div>
        <div style={{display: "flex", flexDirection: "row", gap: "60px"}}>
          <GenericStat 
            onLightDark={"light"}
            onColor={"#e9530d"}
            onStatNumber={jobsCompletedToday}
            onStatName={"Jobs completed"}
            onStatSubtext={"Today"}
          />
          <GenericStat 
            onLightDark={"light"}
            onColor={"#e9530d"}
            onStatNumber={quotesWonToday}
            onStatName={"Quotes won"}
            onStatSubtext={"Today"}
          />
          <GenericStat 
            onLightDark={"light"}
            onColor={"#e9530d"}
            onStatNumber={invoicesToday}
            onStatName={"Total invoices"}
            onStatSubtext={"Today"}
          />
        </div>
      </div>

      {/* <div className="stats__container__alt" style={{marginTop: "1em"}}>
        <div className="stats__container">
          <InvoiceCompletedChart 
            onChartData={chartData}
          />
        </div>
      </div> */}

      <div className="stats__container__alt">
        <div className="stat__column__stacked">
          <div className="stat__stacked__item">
            <GenericStat 
              onLightDark={"dark"}
              onColor={"rgb(170 139 247)"}
              onStatNumber={enquiriesNotQuoted}
              onStatName={"Enquiries"}
              onStatSubtext={"Open"}
            />
          </div>
          <div className="stat__stacked__item">
            <GenericStat 
              onLightDark={"dark"}
              onColor={"#a0ebcc"}
              onStatNumber={quotesRecent}
              onStatName={"Quotes"}
              onStatSubtext={"Open"}
            />
          </div>
          <div className="stat__stacked__item">
            <GenericStat 
              onLightDark={"dark"}
              onColor={"#a0ebcc"}
              onStatNumber={quotesWon}
              onPercentage={true}
              onStatName={"Quotes"}
              onStatSubtext={"Won current month (%)"}
            />
          </div>
          <div className="stat__stacked__item">
            <GenericStat 
              onLightDark={"dark"}
              onColor={"#a0ebcc"}
              onStatNumber={quotesWonYearToDate}
              onPercentage={true}
              onStatName={"Quotes"}
              onStatSubtext={"Won YTD (%)"}
            />
          </div>
        </div>

        <div style={{display: "flex", flexDirection: "column", width: "100%"}}>
          <div className="stats__container">
            <div style={{ display: "flex", flexDirection: "row", gap: "2em" }}>
              <GenericStat 
                onLightDark={"dark"}
                onColor={"rgb(170 139 247)"}
                onStatNumber={enquiriesToday}
                onStatName={"Enquiries"}
                onStatSubtext={"Created today"}
              />
              <GenericStat 
                onLightDark={"dark"}
                onColor={"rgb(170 139 247)"}
                onStatNumber={enquiriesMonth}
                onStatName={"Enquiries"}
                onStatSubtext={"Created this month"}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "row", gap: "2em" }}>
              <GenericStat 
                onLightDark={"dark"}
                onColor={"#a0ebcc"}
                onStatNumber={quotesToday}
                onStatName={"Quotes"}
                onStatSubtext={"Created today"}
              />
              <GenericStat 
                onLightDark={"dark"}
                onColor={"#a0ebcc"}
                onStatNumber={quotesMonth}
                onStatName={"Quotes"}
                onStatSubtext={"Created this month"}
              />
            </div> 
            <div style={{ display: "flex", flexDirection: "row", gap: "1em" }}>
              <GenericStat 
                onLightDark={"dark"}
                onColor={"#aec741"}
                onStatNumber={jobsToday}
                onStatName={"Jobs"}
                onStatSubtext={"Created today"}
              />
              <GenericStat 
                onLightDark={"dark"}
                onColor={"#aec741"}
                onStatNumber={jobsMonth}
                onStatName={"Jobs"}
                onStatSubtext={"Created this month"}
              />
            </div>
          </div>
          <div style={{marginTop: "1em"}}>
            <div>
              <div className="chart__title__container">
                <p style={{ color: "rgb(30, 42, 78)", margin: 0, fontWeight: "bold" }}>Quotes</p>
              </div>
              <MainQuoteWorkChart 
                onChartData={chartData}
              />
            </div>
            <div>
              <div className="chart__title__container">
                <p style={{ color: "rgb(30, 42, 78)", margin: 0, fontWeight: "bold" }}>Jobs</p>
              </div>
              <MainJobWorkChart
                onChartData={chartData}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
